import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EsqueceuSenha = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1: email, 2: código, 3: nova senha
  const [email, setEmail] = useState('');
  const [codigo, setCodigo] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [nome, setNome] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [loading, setLoading] = useState(false);

  const solicitarCodigo = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/solicitar-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.ok) {
        // Buscar nome do usuário
        const userResponse = await fetch(`${BACKEND_URL}/api/auth/verificar-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        });

        if (userResponse.ok) {
          const userData = await userResponse.json();
          setNome(userData.nome);
        }

        setSucesso('Código enviado para seu email!');
        setTimeout(() => {
          setStep(2);
          setSucesso('');
        }, 2000);
      } else {
        setErro(data.detail || 'Email não encontrado no sistema');
      }
    } catch (error) {
      setErro('Erro ao enviar código. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const validarCodigo = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/validar-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, codigo })
      });

      const data = await response.json();

      if (response.ok) {
        setSucesso('Código validado com sucesso!');
        setTimeout(() => {
          setStep(3);
          setSucesso('');
        }, 1500);
      } else {
        setErro(data.detail || 'Código inválido');
      }
    } catch (error) {
      setErro('Erro ao validar código. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const redefinirSenha = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');

    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não coincidem');
      return;
    }

    if (novaSenha.length < 6) {
      setErro('A senha deve ter no mínimo 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/redefinir-senha-com-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, codigo, nova_senha: novaSenha })
      });

      const data = await response.json();

      if (response.ok) {
        setSucesso('Senha redefinida com sucesso!');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setErro(data.detail || 'Erro ao redefinir senha');
      }
    } catch (error) {
      setErro('Erro ao redefinir senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const getStepTitle = () => {
    switch (step) {
      case 1:
        return 'Recuperar Senha';
      case 2:
        return 'Verificar Código';
      case 3:
        return 'Nova Senha';
      default:
        return '';
    }
  };

  const getStepDescription = () => {
    switch (step) {
      case 1:
        return 'Digite seu email para receber o código de verificação';
      case 2:
        return `Código enviado para ${email}`;
      case 3:
        return `Olá, ${nome}! Crie sua nova senha`;
      default:
        return '';
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        maxWidth: '450px',
        width: '100%',
        padding: '40px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{
            background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
            color: 'white',
            padding: '15px',
            borderRadius: '12px',
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '10px',
            display: 'inline-block'
          }}>
            SILVER START
          </div>
          <h2 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1F2937', margin: '20px 0 10px' }}>
            {getStepTitle()}
          </h2>
          <p style={{ fontSize: '14px', color: '#6B7280' }}>
            {getStepDescription()}
          </p>
        </div>

        {/* Progress Indicator */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '10px', 
          marginBottom: '30px' 
        }}>
          {[1, 2, 3].map((s) => (
            <div
              key={s}
              style={{
                width: s === step ? '40px' : '12px',
                height: '12px',
                borderRadius: '6px',
                backgroundColor: s <= step ? '#667eea' : '#E5E7EB',
                transition: 'all 0.3s'
              }}
            />
          ))}
        </div>

        {/* Step 1: Email */}
        {step === 1 && (
          <form onSubmit={solicitarCodigo}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '2px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '15px',
                  transition: 'border 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#667eea'}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
              />
            </div>

            {erro && (
              <div style={{
                padding: '12px',
                background: '#FEE2E2',
                color: '#DC2626',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '20px'
              }}>
                ❌ {erro}
              </div>
            )}

            {sucesso && (
              <div style={{
                padding: '12px',
                background: '#D1FAE5',
                color: '#059669',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '20px'
              }}>
                ✅ {sucesso}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
                marginBottom: '16px'
              }}
            >
              {loading ? 'Enviando...' : 'Enviar Código'}
            </button>

            <button
              type="button"
              onClick={() => navigate('/login')}
              style={{
                width: '100%',
                padding: '14px',
                background: 'transparent',
                color: '#667eea',
                border: '2px solid #667eea',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Voltar ao Login
            </button>
          </form>
        )}

        {/* Step 2: Código de Verificação */}
        {step === 2 && (
          <form onSubmit={validarCodigo}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                Código de Verificação
              </label>
              <input
                type="text"
                value={codigo}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                  setCodigo(value);
                }}
                placeholder="000000"
                required
                maxLength={6}
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '2px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '24px',
                  textAlign: 'center',
                  letterSpacing: '8px',
                  fontWeight: 'bold',
                  transition: 'border 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#667eea'}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
              />
              <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '8px', textAlign: 'center' }}>
                Digite o código de 6 dígitos enviado para seu email
              </p>
            </div>

            <div style={{
              background: '#FEF3C7',
              border: '1px solid #F59E0B',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '20px',
              fontSize: '13px',
              color: '#92400E'
            }}>
              ⚠️ O código expira em <strong>6 minutos</strong> e você tem <strong>3 tentativas</strong>
            </div>

            {erro && (
              <div style={{
                padding: '12px',
                background: '#FEE2E2',
                color: '#DC2626',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '20px'
              }}>
                ❌ {erro}
              </div>
            )}

            {sucesso && (
              <div style={{
                padding: '12px',
                background: '#D1FAE5',
                color: '#059669',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '20px'
              }}>
                ✅ {sucesso}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || codigo.length !== 6}
              style={{
                width: '100%',
                padding: '14px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: (loading || codigo.length !== 6) ? 'not-allowed' : 'pointer',
                opacity: (loading || codigo.length !== 6) ? 0.7 : 1,
                marginBottom: '16px'
              }}
            >
              {loading ? 'Validando...' : 'Validar Código'}
            </button>

            <button
              type="button"
              onClick={() => {
                setStep(1);
                setCodigo('');
                setErro('');
                setSucesso('');
              }}
              style={{
                width: '100%',
                padding: '14px',
                background: 'transparent',
                color: '#667eea',
                border: '2px solid #667eea',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Solicitar Novo Código
            </button>
          </form>
        )}

        {/* Step 3: Nova Senha */}
        {step === 3 && (
          <form onSubmit={redefinirSenha}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                Nova Senha
              </label>
              <input
                type="password"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                required
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '2px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
                onFocus={(e) => e.target.style.borderColor = '#667eea'}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                Confirmar Senha
              </label>
              <input
                type="password"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                placeholder="Digite a senha novamente"
                required
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '2px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
                onFocus={(e) => e.target.style.borderColor = '#667eea'}
                onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
              />
            </div>

            {erro && (
              <div style={{
                padding: '12px',
                background: '#FEE2E2',
                color: '#DC2626',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '20px'
              }}>
                ❌ {erro}
              </div>
            )}

            {sucesso && (
              <div style={{
                padding: '12px',
                background: '#D1FAE5',
                color: '#059669',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '20px'
              }}>
                ✅ {sucesso}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'Redefinindo...' : 'Redefinir Senha'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default EsqueceuSenha;
